// extracted by css-extract-rspack-plugin
var _1 = "T1SNcoMDcovMD_YP";
var _2 = "T1SNcoMDcovMD_YP";
export { _1 as "lb-newposts", _2 as "lbNewposts" }
